document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.sidebar-faq-nested');

  sections.forEach(section => {
    const mainTabs = section.querySelectorAll('.main-tab');
    const subTabs = section.querySelectorAll('.sub-tab');
    const desktopContents = section.querySelectorAll('.faq-sub-content'); // chỉ dùng trên desktop
    const mobileContents = section.querySelectorAll('.mobile-faq-content'); // chỉ dùng trên mobile
    const faqQuestions = section.querySelectorAll('.faq-q');

    // Hàm kiểm tra xem đang ở mobile hay không
    const isMobile = () => window.innerWidth <= 768;

    // 1. Xử lý click Main Tab: mở/đóng sub-categories
    mainTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const mainCategory = tab.parentElement;
        mainCategory.classList.toggle('open');

        // Trên mobile: nếu mở main mà chưa có sub active → tự động active sub đầu tiên
        if (isMobile() && mainCategory.classList.contains('open')) {
          const firstSubInThisMain = mainCategory.querySelector('.sub-tab');
          if (firstSubInThisMain && !firstSubInThisMain.classList.contains('active')) {
            firstSubInThisMain.click();
          }
        }
      });
    });

    // 2. Xử lý click Sub Tab
    subTabs.forEach(sub => {
      sub.addEventListener('click', () => {
        const main = sub.dataset.main;
        const subIdx = sub.dataset.sub;

        // Luôn remove active cũ cho tất cả sub-tab
        subTabs.forEach(s => s.classList.remove('active'));

        // Add active cho sub hiện tại
        sub.classList.add('active');

        if (isMobile()) {
          // === MOBILE: Ẩn tất cả mobile content cũ, chỉ hiện cái tương ứng ===
          mobileContents.forEach(c => c.style.display = 'none');
          const mobileContent = section.querySelector(`.mobile-faq-content[data-main="${main}"][data-sub="${subIdx}"]`);
          if (mobileContent) {
            mobileContent.style.display = 'block';
          }

          // Đảm bảo main category đang mở
          sub.closest('.main-category').classList.add('open');
        } else {
          // === DESKTOP: Dùng cột phải như cũ ===
          desktopContents.forEach(c => c.classList.remove('active'));
          const desktopContent = section.querySelector(`.faq-sub-content[data-main="${main}"][data-sub="${subIdx}"]`);
          if (desktopContent) {
            desktopContent.classList.add('active');
          }

          // Optional: highlight main tab đang active (nếu muốn)
          // mainTabs.forEach(t => t.classList.remove('active'));
          // section.querySelector(`.main-category[data-main="${main}"] .main-tab`)?.classList.add('active');
        }
      });
    });

    // 3. Xử lý accordion (cả desktop và mobile đều dùng chung class .faq-q và .faq-item)
    faqQuestions.forEach(q => {
      q.addEventListener('click', () => {
        const item = q.parentElement;
        item.classList.toggle('open');
      });
    });

    // 4. Khởi tạo: Mở sub đầu tiên khi load trang
    const firstSub = section.querySelector('.sub-tab');
    if (firstSub) {
      // Trigger click để active đúng theo device
      firstSub.click();

      // Đảm bảo main category chứa sub đầu tiên được mở
      firstSub.closest('.main-category').classList.add('open');
    }

    // Optional: Mở một FAQ item đầu tiên trong nội dung active (tùy ý)
    // setTimeout(() => {
    //   const activeContent = isMobile()
    //     ? section.querySelector('.mobile-faq-content[style*="block"]')
    //     : section.querySelector('.faq-sub-content.active');
    //   activeContent?.querySelector('.faq-item')?.classList.add('open');
    // }, 100);
  });

  // Bonus: Handle resize (từ mobile sang desktop và ngược lại)
  // Vì layout khác biệt lớn → reload là cách đơn giản và an toàn nhất
  let resizeTimer;
  // window.addEventListener('resize', () => {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(() => {
  //     if (window.innerWidth > 768 || window.innerWidth <= 768) {
  //       location.reload();
  //     }
  //   }, 300);
  // });
});